import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMask1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMask1"><Path d="M4.5 15.7263V5.5L12 3.5L19.5 5.5V15.7263C19.5 16.5033 19.0499 17.21 18.3458 17.5386L12 20.5L5.65423 17.5386C4.95008 17.21 4.5 16.5033 4.5 15.7263Z" stroke="currentColor"/><Path d="M9 9.5H15" stroke="currentColor"/><Path d="M9 13.5H15" stroke="currentColor"/><Path d="M19.5 8H22V12.5H19.5" stroke="currentColor"/><Path d="M4.5 8H2V12.5H4.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconMask1;
